export const VALIDATE_CLIENT_SUCCESS_CODE = 200;
export const VALIDATE_CLIENT_ERROR_CODES = [401, 404];
